import src from "IMAGE";
export default { src, width: 228, height: 75, blurWidth: 0, blurHeight: 0};
